import { trigger, animate, transition, style } from '@angular/animations';

export const defaultAnimationSpeed: number = 200;
export const originalPositionStyle = style({
  transform: 'translateY(-50%)',
  opacity: 0,
  'z-index': 0,
});
export const finalPositionStyle = style({ transform: 'translateY(0%)', opacity: 1, 'z-index': 1 });
export const slideAnimation = '200ms ease-in-out';

export function getElementEnterTransition() {
  return transition(':enter', [originalPositionStyle, getSlideDownAnimation()]);
}

export function getSlideDownAnimation() {
  return animate(slideAnimation, finalPositionStyle);
}

export function ElementSlideDownAnimation() {
  return trigger('elementSlideDown', [getElementEnterTransition()]);
}
